import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
} from '@material-ui/core'

const useStyles = makeStyles({
  headerCell: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
})

const KeyDatesTable = props => {
  const classes = useStyles()

  return (
    <TableContainer
      component={Paper}
      style={{ width: '100%', margin: 'auto', marginTop: '40px' }}
      data-testid="wip.keyDates"
    >
      <Table aria-label="WIP Report Table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>{props.title}</TableCell>
            <TableCell className={classes.headerCell}>Date(s)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.keyDates?.map((keyDate, index) => (
            <TableRow key={index}>
              <TableCell>{keyDate.Description__c}</TableCell>
              <TableCell>
                {keyDate.StartDate__c && new Date(keyDate.StartDate__c).toLocaleDateString()}
                {keyDate.StartDate__c && keyDate.EndDate__c && ' - '}
                {keyDate.EndDate__c && new Date(keyDate.EndDate__c).toLocaleDateString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default KeyDatesTable
